<div class="d-lg-flex align-items-center bb-light mb-3">
  <h3 class="d-none d-lg-block">Renter Verification</h3>
</div>
<div class="row">
  <div class="col-lg-3 mb-3 mb-lg-0">
    <div class="card sticky verification-card" *ngIf="account$ | async as account">
      <div class="card-body text-center">
        <h5 class="card-title">
          {{ account.name }}
        </h5>
        <ng-container *ngIf="account.verificationStatus == 'Unverified'">
          <div class="alert alert-warning" role="alert">Unverified</div>
          <p class="font-weight-light">If you have an rental placed, a Rubbl admin will review your documents.</p>
        </ng-container>
        <ng-container *ngIf="account.verificationStatus == 'Verified'">
          <div class="alert alert-success" role="alert">Verified</div>
        </ng-container>
        <ng-container *ngIf="account.verificationStatus == 'Denied'">
          <div class="alert alert-danger" role="alert">Denied</div>
        </ng-container>
      </div>
    </div>
  </div>
  <div class="col-lg-9">
    <div class="mb-4" *ngFor="let activity of activities">
      <common-activity-file-upload [activity]="activity" [attr.id]="activity.activityCode"></common-activity-file-upload>
    </div>
  </div>
</div>
